import { formatPhone } from '../../../Utility/phoneNumberFormat';
import { toTitleCase } from '../../../Utility/toTitleCase';
import Loading from '../../../Components/Loading';
import { useAppSelector } from '../../../hooks';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import './MyAccount.css';
import { sendEmail } from '../../../Utility/sendEmail';
// import { makeCall } from 'Utility/makeCallText';

const Account = () => {
    const data = useAppSelector((state) => state.account.accountArr);
    const loading = useAppSelector((state) => state.account.loading);

    if (loading || !data) {
        return <Loading />
    }

    return (
        <>
            {loading ? (
                <Loading />
            ) : (
                <Container>
                    <Row style={{ paddingTop: 20 }}>
                        <Col sm={6} xs={12}>
                            <Card className='shadow my-2'>
                                <CardHeader>
                                    My Contact Information
                                </CardHeader>
                                <CardBody style={{ display: 'flex', gap: 10 }}>
                                    <div style={{ textAlign: 'left' }}>
                                        <span className='d-grid'>Name:</span>
                                        <span className='d-grid'>Mobile Phone:</span>
                                        <span className='d-block'>Zoom Direct Phone:</span>
                                        <span className='d-block'>Email:</span>
                                    </div>
                                    <div style={{ textAlign: 'left' }}>
                                        <span className='d-block'>{toTitleCase(data?.name)}</span>
                                        <span className='d-block'>{data?.mobile ? formatPhone(data?.mobile) : 'N/A'}</span>
                                        <span className='d-block'>{formatPhone(data?.phone)}</span>
                                        <span className='d-block'>{data?.email}</span>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm={6} xs={12}>
                            <Card className='shadow my-2'>
                                <CardHeader>
                                    My Manager's Information
                                </CardHeader>
                                <CardBody style={{ display: 'flex', gap: 10}}>
                                    <div style={{ textAlign: 'left' }}>
                                        <span className='d-grid'>Name:</span>
                                        <span className='d-grid'>Mobile Phone:</span>
                                        <span className='d-block'>Zoom Direct Phone:</span>
                                        <span className='d-block'>Email:</span>
                                    </div>
                                    <div style={{ textAlign: 'left' }}>
                                        <span className='d-block'>{toTitleCase(data?.branchData["Z_MGR_NAME"])}</span>
                                        <span className='d-block'>{formatPhone(data?.branchData["Z_MGR_MOBILE"])}</span>
                                        <span className='d-block'>{formatPhone(data?.branchData["Z_MGR_DID"])}</span>
                                        <a 
                                            className='d-block'
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => sendEmail(data?.branchData["Z_MGR_EMAIL"])}
                                        >
                                            {data?.branchData["Z_MGR_EMAIL"]}
                                        </a>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm={6} xs={12}>
                            <Card className='shadow my-2'>
                                <CardHeader>
                                    My Branch Information
                                </CardHeader>
                                <CardBody>
                                    <div style={{ display: 'flex', gap: 10 }}>
                                        <div style={{ textAlign: 'left' }}>
                                            <span className='d-grid'>Branch:</span>
                                            <span className='d-grid'>Branch #:</span>
                                            <span className='d-block'>Branch Phone:</span>
                                            <span className='d-block'>Branch Fax:</span>
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <span className='d-block'>{toTitleCase(data?.branchData["Z_LOCATION"])}</span>
                                            <span className='d-block'>{data?.branch}</span>
                                            <span className='d-block'>{formatPhone(data?.branchData.PHONE)}</span>
                                            <span className='d-block'>{formatPhone(data?.branchData["Z_CONTACT_FAX"])}</span>
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'start', marginTop: 10 }}>
                                        <span>Address:</span>
                                        <br />
                                        <span>{toTitleCase(data?.branchData["Z_SHIPTO_STREET1"])}</span>
                                        {data?.branchData["Z_SHIPTO_STREET2"] && 
                                            <span>{toTitleCase(data?.branchData["Z_SHIPTO_STREET2"])}</span>
                                        }
                                        <br />
                                        <span>{toTitleCase(data?.branchData["Z_SHIPTO_CITY"])}, </span>
                                        <span>{data?.branchData["Z_SHIPTO_STATE"]} </span>
                                        <span>{data?.branchData["Z_SHIPTO_ZIP"]}</span>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            )}
        </>
    )
};

export default Account;